<div class="otp-container">

  <div class="otp-card">

    <div class="logo">
     <img src="../assets/Walgreens_Logo.png" class="img-fluid" />   
    </div>

    <div class="email-row">

      <span class="back-arrow" (click)="backClick()">
        ←
      </span>

      <span class="email">
        {{ email }}
      </span>

    </div>

    <h1>Enter Code</h1>

    <p class="subtitle">
      If the email address is registered, a code will be sent to {{ email }}.
    </p>
    <form [formGroup]="otpForm">
    <div class="form-group">

          <!-- Inline Validation -->

    <div class="error"
      *ngIf="otpForm.get('otpCode')?.touched && otpForm.get('otpCode')?.invalid || error">

      <!-- Required -->

      <small *ngIf="otpForm.get('otpCode')?.errors?.['required']">
        Code is required
      </small>

      <!-- Invalid OTP -->

      <small *ngIf="otpForm.get('otpCode')?.errors?.['minlength']">
        Code must be 6 digits
      </small>

      <!-- Wrong OTP -->

      <small *ngIf="error">
        {{error}}
      </small>

    </div>
      <input
        type="text" required #otpInput  
        placeholder="Enter code" minlength="6"
        inputmode="numeric" maxlength="6" (input)="onInput($event,'otpCode')"
        formControlName="otpCode" 
      />

    </div>

    <div class="button-group">

      <button 
        class="button-primary"
        (click)="verifyOtp()"
      >
        Sign In
      </button>

    </div>
    </form>
  </div>

</div>